const menuList = {
  en: {
    translation: {
      // ADD INGREDIENT SWEET ALERT
      cancel_button: "Cancel",
      total_button: "Total",
      remove_title: "Remove ingredients",
      remove_item: "Remove",
      add_item: "",
      note: "Personalize your choice",
      add_title: "Add ingredients",

      //
      isRequired: "required",
      isOptional: "optional",

      timetable: "How long do you want to order?"
    }
  },
  it: {
    translation: {
      // ADD INGREDIENT SWEET ALERT,
      cancel_button: "Annulla",
      total_button: "Totale",
      remove_title: "Rimuovi ingredienti",
      remove_item: "Rimuovi",
      add_item: "",
      note: "Personalizza la tua scelta",
      add_title: "Aggiungi ingredienti",

      //
      isRequired: "richiesto",
      isOptional: "facoltativo",

      timetable: "Per quando vuoi ordinare?"
    }
  }
};

export default menuList;
